<template>
  <AgGrid
    :options="options"
    :row-data="data"
    class="subscriptions-table"
    @row-selected="selectRow"
    @ready="tableReady"
    @cell-value-changed="cellValueChanged"
  >
    <template #header>
      <Grid gaf="column" justify-content="space-between" align-items="center">
        <div class="text-body-4 text-secondary-1">
          Select subscriptions for {{ isPlaceOrders ? 'place order' : 'price request' }}:
        </div>

        <Grid
          v-if="isPlaceOrders"
          gaf="column"
          align-items="center"
          gap="var(--r-space-md)"
          class="bulk-update"
          :class="{ 'no-pointer-events disabled': !selectedIds.length }"
        >
          <div class="text-heading-3 text-secondary-1 q-pr-sm">Bulk update:</div>
          <RInput
            v-model.trim="inputValue"
            no-label
            no-hint
            no-feedback-icon
            placeholder="Enter new value"
            style="width: 200px"
          />
          <RBtn :disable="!inputValue" size="small" type="tertiary" @click="onBulkUpdate">Update Selected rows</RBtn>
        </Grid>
      </Grid>
    </template>
  </AgGrid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { options } from './options'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [options],

  props: {
    data: Array,
    isPlaceOrders: Boolean
  },

  data: () => ({
    selectedIds: [],
    inputValue: null
  }),

  methods: {
    // access from parent
    getSelectedIds() {
      return this.selectedIds
    },

    selectRow({ row, isSelected }) {
      if (isSelected) this.selectedIds.push(row.id)
      else this.selectedIds = this.selectedIds.filter(subId => subId !== row.id)
    },

    tableReady(agGrid) {
      this.selectedIds = []
      agGrid.api.selectAll()
    },

    updateRows(items) {
      this.$emit('start-loader')

      apiTo.MODIFY_SUBSCRIPTION_PERIODS({ items }).finally(() => this.$emit('re-fetch'))
    },

    onBulkUpdate() {
      const items = this.selectedIds.map(id => ({ id, member_purchase_order_reference: this.inputValue }))

      this.updateRows(items)
    },

    cellValueChanged({ newValue, data }) {
      this.updateRows([{ id: data.id, member_purchase_order_reference: newValue }])
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.subscriptions-table {
  @include table-with-no-filters;
}
</style>
